import downloader from "./downloader/youtube.thumbnail.downloader.router";

export default {
  path: "thumbnail",
  component: () => import("~/pages/_.vue"),
  children: [{ ...downloader }]
};
